/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsAuditReportsGetGipReportEvidenceExportUrlQueryResponse, AuditReportsAuditReportsGetGipReportEvidenceExportUrlPathParams, AuditReportsAuditReportsGetGipReportEvidenceExportUrl401, AuditReportsAuditReportsGetGipReportEvidenceExportUrl403, AuditReportsAuditReportsGetGipReportEvidenceExportUrl404 } from "../models/AuditReportsAuditReportsGetGipReportEvidenceExportUrl";

export function getAuditReportsAuditReportsGetGipReportEvidenceExportUrlUrl(id: AuditReportsAuditReportsGetGipReportEvidenceExportUrlPathParams["id"]) {
  const res = { method: 'GET', url: `/audit-reports/v1/reports/gip/report/${id}/export-url` as const }
  return res
}

/**
 * @summary Get export URL for existing report
 * {@link /audit-reports/v1/reports/gip/report/:id/export-url}
 */
export async function auditReportsAuditReportsGetGipReportEvidenceExportUrl(id: AuditReportsAuditReportsGetGipReportEvidenceExportUrlPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditReportsAuditReportsGetGipReportEvidenceExportUrlQueryResponse, ResponseErrorConfig<AuditReportsAuditReportsGetGipReportEvidenceExportUrl401 | AuditReportsAuditReportsGetGipReportEvidenceExportUrl403 | AuditReportsAuditReportsGetGipReportEvidenceExportUrl404>, unknown>({ method : "GET", url : getAuditReportsAuditReportsGetGipReportEvidenceExportUrlUrl(id).url.toString(), ... requestConfig })
  return res.data
}